import { render } from "./PackageFormPage.vue?vue&type=template&id=09f60f9e&ts=true"
import script from "./PackageFormPage.vue?vue&type=script&lang=ts"
export * from "./PackageFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__